import { getToken } from "@/utils/authHelpers";
import {API_BASE_URL} from "@/utils/api";
import axios from "axios";

export const deleteStudyApi = async (studyId: string) => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }
  try {
    await axios.delete(`${API_BASE_URL}/delete-study/${studyId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      status: "success",
      message: "Study deleted successfully!",
    };
  } catch (err) {
    console.error(err);
    throw new Error("Failed to delete study");
  }
};
